import React, { useEffect, useState } from "react";
import { Container, Card } from "react-bootstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { getDocs, collection } from "firebase/firestore/lite";
import { db } from "../firebase/firebase-config";

const Products = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    fetchProducts();
  }, []);

  async function fetchProducts() {
    try {
      const productsCollectionRef = collection(
        db,
        "sacco",
        "TEKiK01inpRB3NFlK65S",
        "products"
      );
      const productsSnapshot = await getDocs(productsCollectionRef);
      const fetchedProducts = productsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setProducts(fetchedProducts);
    } catch (err) {
      console.error("Error fetching products: ", err.message);
    }
  }

  return (
    <>
      <Navbar />
      <Container className="py-5">
        <h2 className="text-center mb-4">Our Products</h2>

        {/* Various Loan Products Section */}
        <Card className="p-4 shadow-lg mb-5">
          <h3 className="text-2xl font-semibold text-center mb-4">
            Various Loan Products
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {products
              .filter(
                (product) => product?.productCategory === "Various Loan Products"
              )
              .map((loan, index) => (
                <div
                  key={index}
                  className="p-6 bg-white rounded-lg shadow text-center"
                >
                  <img
                    src={loan.image}
                    alt={loan.name}
                    className="w-full h-40 object-cover mb-4 rounded"
                  />
                  <h4 className="text-xl font-semibold mb-2">{loan.name}</h4>
                  <p className="text-gray-600">{loan.details}</p>
                </div>
              ))}
          </div>
        </Card>

        {/* Saving Products Section */}
        <Card className="p-4 shadow-lg">
          <h3 className="text-2xl font-semibold text-center mb-4">
            Saving Products
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {products
              .filter(
                (product) => product?.productCategory === "Saving Products"
              )
              .map((saving, index) => (
                <div
                  key={index}
                  className="p-6 bg-white rounded-lg shadow text-center"
                >
                  <img
                    src={saving.image}
                    alt={saving.name}
                    className="w-full h-40 object-cover mb-4 rounded"
                  />
                  <h4 className="text-xl font-semibold mb-2">{saving.name}</h4>
                  <p className="text-gray-600">{saving.details}</p>
                </div>
              ))}
          </div>
        </Card>
      </Container>
      <Footer />
    </>
  );
};

export default Products;
